export default "__VITE_ASSET__CNeCkMc$__"